let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iLKT4")).then(() => parcelRequire('aZcUb'));